import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./Success.scss";

function Success({ show, handleClose, handleSubmit }) {
  const { t } = useTranslation(["register"]);

  return (
    <div id="SuccessModal">
      <Modal centered show={show} onHide={handleClose} backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>{t("success.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body text-center">
            <p>{t("success.text_1")}</p>
            <p>{t("success.text_2")}</p>
            <p>{t("success.text_3")}</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          {/* 
          <Button onClick={handleSubmit} className="success-button">
            {t("success.button")}
          </Button>
           */}
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default Success;
